module.exports = __webpack_public_path__ + "assets/pdf/E15-en-daily-satellite-monitoring.9c9f4bb2.pdf";